import ApiInstance from './instance'
import {
  URL_MAPPING,
  IFacilityDTO
} from '@zunta/configurations'

const { import: importUrls } = URL_MAPPING

export default class ImportApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  importFacilities (facilitiesDTO: IFacilityDTO[], file: File): Promise<Array<IFacilityDTO> | any> {
    const form = new FormData()
    form.append('residents', file)
    form.append('facilities', JSON.stringify(facilitiesDTO))
    return this.instance.doPost(`${importUrls.prefix}${importUrls.importFacilities.path}`, form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
